import { gql } from '@apollo/client';
import IconSingleService from '@apollo/icons/default/IconSingleService.svg';
import {
  Group,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@apollo/orbit';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const CompositionBuildInputsFragment = gql`
  fragment CompositionBuildInputsFragment on CompositionBuildInputs {
    subgraphs {
      name
      schemaHash
      routingUrl
    }
  }
`;
interface Props {
  buildInputs: GraphQLTypes.CompositionBuildInputsFragment;
  className?: string;
}

export const CompositionBuildInputs = ({ buildInputs, className }: Props) => (
  <>
    <section className={className}>
      <Heading as="h3" size="lg">
        Subgraphs
      </Heading>
      <div className="text-secondary">
        These are the subgraphs that make up the build for your federated graph.{' '}
      </div>
    </section>
    <TableContainer>
      <Table size="condensed">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Version</Th>
            <Th>Routing URL</Th>
          </Tr>
        </Thead>
        <Tbody>
          {(buildInputs.subgraphs ?? []).map((subgraph) => (
            <Tr key={subgraph.name}>
              <Td>
                <Group gap={2}>
                  <IconSingleService className="text-icon-primary" />
                  {subgraph.name}
                </Group>
              </Td>
              <Td>{subgraph.schemaHash.substring(0, 6)}</Td>
              <Td>{subgraph.routingUrl}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  </>
);
